// Demo-tester admin — reads the telemetry the /demo experience writes (demoActivity/*
// + usage/demo:*), via the admin-gated adminApi ops. Keyed by the 6-char passkey.
import { callAdmin } from './adminApi';

export interface TesterRow {
  key: string;
  lastSeen: number;      // ms epoch (0 = never)
  lastEvent: string;
  eventCount: number;
  lastIp: string;
  ips: string[];
  tokensTotal: number;
  tokensIn: number;
  tokensOut: number;
  calls: number;
  cap: number;
}
export interface TesterEvent { event: string; detail: string; ip: string; ts: number; userAgent: string; }

export const demoStats = () => callAdmin<{ rows: TesterRow[] }>('demoStats').then((r) => r.rows);
export const demoEvents = (key: string) => callAdmin<{ events: TesterEvent[] }>('demoEvents', { key }).then((r) => r.events);
export const resetKey = (key: string) => callAdmin('resetKey', { key });
